import { useEffect, useRef } from 'react';

export default function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value; // Update the ref's current value after every render
  });

  return ref.current; // Return the value from the *previous* render
}